import React, { useState } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IAccountReceivableDetail } from "../../../../AccountTypes";
import { useReceivableModel } from "./receivableModel";
import { creditFlagRender, formatLocalDateTime } from "@/utils/utils";
import { SnippetsOutlined } from "@ant-design/icons";
import PreviewModal from "@/components/YhPreview/index";
import { httpRequest } from "@/utils/HttpRequest";
import { convertRes2Blob } from "@/utils/exportFile";
import { getBaseImgLookUrl } from "@/utils/constants"
import YhTootip from "@/components/YhTootip";



export function ReceivableDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, setSelectedData,
        selectedData,
        loading,
    } = useReceivableModel();

    const columns: ColumnsType<IAccountReceivableDetail> = [
        {
            align: "center",
            width: 60,
            title: '序号',
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            width: 200,
            title: '单据编号',
            dataIndex: 'tradeCode',
            render: (text, recode) => <YhTootip text={text}  />
        },
        {
            align: "center",
            title: '账户类型',
            dataIndex: 'accountTypeName',
        },
        {
            align: "center",
            title: '单据类型',
            dataIndex: 'tradeTypeName',
        },
        {
            align: "center",
            title: '单据金额',
            dataIndex: 'billAmount',
        },
        {
            align: "center",
            title: '充值金额',
            dataIndex: 'rechargeAmount',
        },
        {
            align: "center",
            title: '应收金额',
            dataIndex: 'receiveAmount',
        },
        {
            align: "center",
            title: '创建时间',
            dataIndex: 'createTime',
            render: (e => formatLocalDateTime(e))
        },
    ];

    return (
        <>
            <Table
                loading={loading}
                // rowSelection={{
                //     type: "radio",
                //     onChange: (selectedRowKeys: React.Key[], selectedRows: IAccountReceivableDetail[]) => {
                //         setSelectedRowKeys(selectedRowKeys);
                //         selectedRows.length > 0 ? setSelectedData(selectedRows[0]) : setSelectedData(undefined)
                //     },
                //     selectedRowKeys
                // }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    showTotal: (total: number) => `共${total}条`,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then();
                    }
                }}
                // onRow={record => {
                //     return {
                //         onClick: event => {
                //             if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                //                 setSelectedRowKeys([]);
                //                 setSelectedData(undefined)
                //             } else {
                //                 setSelectedRowKeys([record.key]);
                //                 setSelectedData(record)
                //             }
                //         },
                //     };
                // }}
                scroll={{ x: 'max-content' }}
            />
        </>
    )
}

